const styles = theme => ({
  contractListContainer: {
    margin: '0px 0px 48px',
  },
  resultTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingBottom: '15px',
    marginBottom: '16px',
    borderBottom: '1px solid #EBEEF3',
    '& > h1': {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: theme.palette.primary.ascent,
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    '& > p': {
      fontWeight: 500,
      color: theme.palette.primary.darkGrey,
    },
  },
  noDataContainer: {
    width: '100%',
    textAlign: 'center',
    padding: '5em 0px',
    '& p': {
      color: theme.palette.primary.darkGrey,
    },
  },
  contractList: {
    marginBottom: '24px',
    paddingTop: '0px',
    paddingBottom: '16px',
  },
  listItemContainer: {
    borderRadius: '0px',
    marginBottom: '12px',
    background: theme.palette.primary.white,
    border: `1px solid #EBEEF3`,
    '&:hover': {
      background: theme.palette.primary.cardHover,
      border: `1px solid ${theme.palette.primary.cardHoverBorder}`,
    },
    '&:focus': {
      background: theme.palette.primary.cardHover,
      border: `1px solid ${theme.palette.primary.cardHoverBorder}`,
    },
    '&:active': {
      background: theme.palette.primary.cardHover,
      border: `1px solid ${theme.palette.primary.cardHoverBorder}`,
    },
  },
  listItem: {
    padding: '16px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 10px',
    },
    '&:hover': {
      background: theme.palette.primary.cardHover,
      border: `1px solid ${theme.palette.primary.cardHoverBorder}`,
    },
  },
  listItemText: {},
  itemTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& h3': {
      // maxWidth: '90%',
      fontSize: '18px',
      overflow: 'hidden',
      // textOverflow: 'ellipsis',
      color: theme.palette.primary.ascenty,
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
      },
    },
  },
  initibadges: {
    '&:before': {
      content: "''",
      width: '10px',
      height: '10px',
      borderRadius: '50%',
    },
    textTransform: 'lowercase',
    '& > span': {
      display: 'inline-block',
      '&::first-letter': {
        textTransform: 'uppercase',
      },
    },
    fontSize: '14px',
    minWidth: '76px',
    flexShrink: '0',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      minWidth: '0px',
      padding: '0px',
      maxHeight: '24px',
    },
    background: 'none',
  },
  greenChip: {
    '&:before': {
      backgroundColor: theme.palette.primary.adgmGreen,
    },
  },
  greyChip: {
    '&:before': {
      backgroundColor: theme.palette.primary.darkGrey,
    },
  },
  redChip: {
    '&:before': {
      backgroundColor: theme.palette.secondary.errorRed,
    },
  },
  orangeChip: {
    '&:before': {
      backgroundColor: theme.palette.primary.warningMango,
    },
  },
  itemDescription: {
    paddingTop: '12px',
    display: 'grid',
    gap: '30px 20px',
    gridTemplateColumns: 'repeat( auto-fit, minmax(100px, 1fr) )',
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '100%',
      whiteSpace: 'normal',
      '& > p:first-child': {
        color: theme.palette.primary.darkGrey,
        marginBottom: '2px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '20px 10px',
      '& p': {
        fontSize: '12px',
      },
    },
  },
  // valueAndUnit: {
  //   display: 'flex',
  //   flexDirection: 'row !important',
  //   columnGap: '26px',
  //   '& > div > p:first-child': {
  //     color: theme.palette.primary.darkGrey,
  //     marginBottom: '2px',
  //   },
  //   '& p': {
  //     fontSize: '12px',
  //   },
  // },
  itemFooter: {
    marginTop: '10px',
    paddingTop: '10px',
    borderTop: '1px solid #EBEEF3',
    display: 'flex',
    flexDirection: 'row !important',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    rowGap: '10px',
    '& p:first-child': {
      paddingRight: '4px',
    },
    '& p:nth-child(3)': {
      padding: '0px 4px',
    },
  },
  footerDates: {
    display: 'flex',
    flexDirection: 'row !important',
    '& > p': {
      color: theme.palette.primary.darkGrey,
      marginBottom: '2px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
      },
    },
  },
  listItemIcon: {
    minWidth: 'auto',
    alignSelf: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      right: 0,
      top: 0,
    },
  },
  itemCheckbox: {
    '& svg': {
      height: '30px',
      width: '30px',
    },
  },
  itemCheckboxChecked: {
    color: `${theme.palette.primary.main} !important`,
  },
  contractCardTop: {
    '& h3': {
      fontSize: '16px',
    },
    '& h6': {
      fontSize: '12px',
    },
    '& p': {
      fontSize: '14px',
      maxWidth: '100%',
      whiteSpace: 'normal',
    },
  },
  divider: {
    width: '100%',
    margin: '24px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 0',
    },
  },
  contractCardBottom: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  contractDetails: {
    gap: '30px',
    flexWrap: 'wrap',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  body1_d: {
    fontSize: '14px',
    fontWeight: '500',
  },
  contractLink: {
    color: theme.palette.primary.main,
    '& >span': {
      fontWeight: '500',
    },
    verticalAlign: 'middle',
  },
  rotateY180: {
    transform: 'rotateY(180deg)',
  },
});

export default styles;
